import { render, staticRenderFns } from "./Estrangeiro.vue?vue&type=template&id=5b15ae8f"
import script from "./Estrangeiro.vue?vue&type=script&lang=js"
export * from "./Estrangeiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports